export const KA_GUIDELINE_ORDER = [
  'answering',
  'intent',
  'fallback',
  'faq',
  'spamFilter',
  'personalizationToolChat',
  'personalizationToolGeneration',
];

export const KA_GUIDELINE_TYPES = {
  answering: {
    key: 'answering',
    expandedKey: 'kaAnsweringExpanded',
    valueKey: 'kaAnsweringGuideline',
    defaultKey: 'answeringGuideline',
    label: 'Answering guidelines',
    icon: 'ChatFilled',
    tooltip:
      'Define how the AI should structure and present responses. Include tone, format, length, and specific instructions for delivering accurate, helpful answers based on the available information.',
    placeholder:
      "Add rules the agent must follow in every response or click 'Help me write' to auto-fill based on your inputs",
    hasHelpMeWrite: true,
  },
  intent: {
    key: 'intent',
    expandedKey: 'kaIntentExpanded',
    valueKey: 'kaIntentGuideline',
    defaultKey: 'intentGuideline',
    label: 'Intent guidelines',
    icon: 'ListenFilled',
    tooltip:
      'Specify what types of questions or topics the AI should focus on. Define the scope, context, and key areas where the AI should provide assistance, helping it understand when and how to engage with user queries.',
    placeholder: 'Add rules the agent must follow in every response.',
    hasIntentDetection: true,
  },
  fallback: {
    key: 'fallback',
    expandedKey: 'kaFallbackExpanded',
    valueKey: 'kaFallbackGuideline',
    defaultKey: 'fallbackGuideline',
    label: 'Fallback guidelines',
    icon: 'FallbackFilled',
    tooltip:
      'Define what the AI should do when it encounters questions it cannot answer or when information is insufficient. Specify alternative actions like providing general guidance, or asking clarifying questions.',
    placeholder: 'Add fallback guidelines',
  },
  faq: {
    key: 'faq',
    expandedKey: 'kaFaqExpanded',
    valueKey: 'kaFaqGuideline',
    defaultKey: 'faqGuideline',
    label: 'FAQ guidelines',
    icon: 'FaqGuideline',
    tooltip:
      'Define how the AI should structure and present FAQ responses. Include tone, format, length, and specific instructions for delivering accurate, helpful answers based on the available information.',
    placeholder: 'Add FAQ guidelines',
  },
  spamFilter: {
    key: 'spamFilter',
    expandedKey: 'kaSpamFilterExpanded',
    valueKey: 'kaSpamFilterGuideline',
    defaultKey: 'spamFilterGuideline',
    label: 'Email spam guidelines',
    icon: 'FaqGuideline',
    tooltip:
      'Define rules to identify whether an incoming message should be treated as spam before simulation.',
    placeholder: 'Add email spam guidelines',
  },
  personalizationToolChat: {
    key: 'personalizationToolChat',
    expandedKey: 'kaPersonalizationToolChatExpanded',
    valueKey: 'kaPersonalizationToolChatGuideline',
    defaultKey: 'personalizationToolChatGuideline',
    label: 'Personalisation tool chat guidelines',
    icon: 'ChatFilled',
    tooltip:
      'Define how the AI should behave during personalisation tool chat interactions. Include tone, scope, and response rules.',
    placeholder: 'Add personalisation tool chat guidelines',
  },
  personalizationToolGeneration: {
    key: 'personalizationToolGeneration',
    expandedKey: 'kaPersonalizationToolGenerationExpanded',
    valueKey: 'kaPersonalizationToolGenerationGuideline',
    defaultKey: 'personalizationToolGenerationGuideline',
    label: 'Personalisation tool generation guidelines',
    icon: 'ChatFilled',
    tooltip:
      'Define how the AI should generate personalisation tool outputs. Include format, constraints, and quality rules.',
    placeholder: 'Add personalisation tool generation guidelines',
  },
};

export const createEmptyKaDefaultGuidelines = () => ({
  answeringGuideline: '',
  intentGuideline: '',
  fallbackGuideline: '',
  faqGuideline: '',
  spamFilterGuideline: '',
  personalizationToolChatGuideline: '',
  personalizationToolGenerationGuideline: '',
});
